import React from 'react';
import { useTranslation } from 'react-i18next';

import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import Faqs from '../components/Faqs';

function Faq() {
    const { t } = useTranslation();

    return (
        <div>
            <NavigationBar />
            <h1>{t('FAQ')}</h1>
            <MediaList mediaKey='FAQ_TOP' maxItems={1} isShortLine={true} />
            <Faqs />
            <MediaList mediaKey='FAQ_BOTTOM' maxItems={1} isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default Faq;
